import {Card, Flex} from "antd";
import { useEffect } from "react";
import {Outlet} from "react-router-dom";
import { useDispatch } from 'react-redux';
import { initializeAsync } from "../../app/store/reducers/auth/authReducer";
import EventBus from './../../app/eventBus/EventBus';
import { AUTHENTICATION_LOGIN_SUCCESS } from "../../app/eventBus/authEvents/authEvents";
import {useNavigate} from "react-router-dom"

const AuthLayout = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  
  useEffect(() => {
    const handlerLogin = EventBus.on(AUTHENTICATION_LOGIN_SUCCESS, () => {
      dispatch(initializeAsync())
      navigate("/")
    })

    return () => {
      EventBus.remove(AUTHENTICATION_LOGIN_SUCCESS, handlerLogin)
    }
  }, [])



  return (
    <>
      <Card>
        <Flex justify="center">
          <Outlet />
        </Flex>
      </Card>
    </>
  );
};

export default AuthLayout;
